module.exports = __webpack_public_path__ + "img/video-assist-wide.d05378d7.svg";